import { parse, stringify } from 'qs';

import React from 'react';
import SparkMD5 from 'spark-md5';

import CommentBody from './CommentBody.jsx';
import Timestamp from './Timestamp.jsx';
import AvatarContainer from './AvatarContainer.jsx';
import withFormContainer from './withFormContainer.jsx';
import Divider from './Divider.jsx';

import './UserHistory.css';

class UserHistory extends React.Component {

    static defaultProps = {
        perPage: 10
    };

    state = {
        comments: null,
        page: 1
    };

    componentDidMount() {

        this.props.sendResizeEvent();

        this.props.changeLoading(true)
            .then(() => {

                const { projectId, userId } = this.props;
                const url = `https://total-user-comments.storage.commentbox.io/${projectId}/${userId}.json`

                return fetch(url, { mode: 'cors' })
                    .then(response => {

                        if(!response.ok) {
                            throw new Error();
                        }
                        return response.json().then(({ data }) => data);

                    })
                    .catch(() => []);
            })
            .then(comments => this.setState({ comments }, () => {

                this.props.changeLoading(false);
            }));
    }

    componentDidUpdate() {
        this.props.sendResizeEvent();
    }

    onChangePage = () => {

        this.setState({ page: this.state.page + 1 });
    };

    get comments() {

        if (!this.state.comments) {
            return null;
        }

        const { perPage } = this.props;
        const { page } = this.state;

        return this.state.comments.slice(0, page * perPage).map(comment => {

            const location = document.createElement('a');
            location.href = comment.url;
            const params = parse(location.search.replace('?', ''));
            params[comment.tlcParam] = SparkMD5.hash(comment.id);
            location.search = `?${stringify(params)}`;


            const props = {
                image: comment.userPhotoURL,
                right: (
                    <div className="comment-content">
                        <div className="body">
                            <CommentBody value={comment.body} />
                        </div>
                        <div className="actions">
                            <Timestamp key="timestamp" value={comment.createdAt} /> <Divider /> <a rel="nofollow" target="_blank" href={location.href}><span className="icon-open_in_new"/> go to page</a>
                        </div>
                    </div>
                )
            };

            return (
                <li key={comment.id}>
                    <AvatarContainer {...props} />
                </li>
            );

        });
    }

    get loadMoreButton() {

        if (!this.state.comments) {
            return (
                <button className="btn primary-button" disabled={true}>
                    Loading...
                </button>
            );
        }

        const hasMore = (this.state.page * this.props.perPage) < this.state.comments.length;

        return (
            <button className="btn primary-button" type="button" onClick={this.onChangePage} disabled={!hasMore}>
                {hasMore ? 'Load more' : 'No more comments'}
            </button>
        );

    }

    render() {
        return (
            <div className="user-history">
                <h3 className="form-container-header">
                    {this.props.userDisplayName.split(' ')[0]}'s recent history
                </h3>

                <ul className="comments">
                    {this.comments}
                </ul>
                <div className="load-more">
                    {this.loadMoreButton}
                </div>
            </div>
        );
    }
}

export default withFormContainer(UserHistory);



// WEBPACK FOOTER //
// ./src/components/UserHistory.jsx